module.exports = __webpack_public_path__ + "static/media/mobile.1928157a.svg";